import { Component, OnInit } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TdDialogService, ITdDataTableColumn } from '@covalent/core';
import { Route } from '@angular/router/src/config';
import { AuthenticationService } from '../../../../shared/services/authentication.service';
import { ReceivingService } from '../../../receiving/receiving.service';
import { PrintingService } from '../../../../shared/services/printing.service';
import { ProductService } from '../../../purchasing/products/product.service';
import { Piece } from '../../../inventory/piece';
import { Product } from '../../../purchasing/products/product';
import { InventoryService } from '../../../inventory/inventory.service';


@Component({
  selector: 'app-print-labels',
  templateUrl: './print-labels.component.html',
  styleUrls: ['./print-labels.component.scss'],
  providers: [ReceivingService, PrintingService, ProductService, InventoryService]
})
export class PrintLabelsComponent implements OnInit {
  receivingNumber: string;
  items: any[] = [];
  grouped_items: any[] = [];

  columns: ITdDataTableColumn[] = [
    { name: 'printed', label: '' },
    { name: 'piece_no', label: 'Piece #' },
    { name: 'length', label: 'Length' },
    { name: 'reprint', label: 'Reprint' },
  ];

  constructor(private router: Router,
    private _dialogService: TdDialogService,
    private _receivingService: ReceivingService,
    private _printingService: PrintingService,
    private _inventoryService: InventoryService,
    private _productService: ProductService,
    private location: Location,
    public _authService: AuthenticationService
  ) { }

  ngOnInit() {
  }

  goBack(): void {
    this.location.back();
  }

  load() {
    if (!this.receivingNumber) {
      this._dialogService.openAlert({ title: 'Invalid data', message: 'Please enter a valid Receiving Number' });
    }

    this._receivingService.getReceivingItemsByReceivingNumber(this.receivingNumber).subscribe(
      recv_items => {

        if (Array.isArray(recv_items) && recv_items.length > 0) {

          this.items = recv_items;
          // Group items by color, (sorted previously by piece no)
          this.items.sort((y, z) => { return (y['piece_no'] > z['piece_no']) ? 1 : -1 }).forEach(
            item => {
              let this_group = this.grouped_items.find(i => { return item['design'] + '/' + item['color'] == i['design_color'] });

              if (this_group != null) {
                this_group.pieces.push(item);
              } else {
                this.grouped_items.push({ design_color: item['design'] + '/' + item['color'], pieces: [item] })
              }
            }
          );

          this.grouped_items.sort((a, b) => { return (a['design_color'] > b['design_color']) ? 1 : -1 });

        } else {
          this._dialogService.openAlert({ title: 'Invalid data', message: 'Please enter a valid Receiving Number' });
        }

      }
    );
  }

  printedStatusText() {
    let totalPieces: number = this.items.length;
    let printedPieces: number = 0;

    this.grouped_items.forEach(
      g => {
        g.pieces.forEach(
          p => {
            printedPieces += (p['printed'] ? 1 : 0);
          }
        )
      }
    );

    return printedPieces + '/' + totalPieces + ' labels printed';
  }

  printedStatusValue() {
    let totalPieces: number = this.items.length;
    let printedPieces: number = 0;

    this.grouped_items.forEach(
      g => {
        g.pieces.forEach(
          p => {
            printedPieces += (p['printed'] ? 1 : 0);
          }
        )
      }
    );

    return (printedPieces / totalPieces) * 100;
  }

  printGroup(pieces: any[]) {
    pieces.forEach(
      p => {
        this.printOneRoll(p);
        p['printed'] = true;
      }
    )
    this._dialogService.openAlert({ title: 'Printed!', message: 'Labels sent to queue' });
  }

  print() {
    if (!this.receivingNumber) {
      this._dialogService.openAlert({ title: 'Invalid data', message: 'Please enter a valid Receiving Number' });
    }

    this._receivingService.getReceivingItemsByReceivingNumber(this.receivingNumber).subscribe(
      items => {
        this._dialogService.openConfirm({
          title: 'Confirm',
          // if longer than 10 only show the first 10
          message: 'The following piece labels will be printed: ' +
            items.map(i => i.piece_no).slice(0, 10).join(', ') +
            (items.length > 10 ? '... and ' + (items.length - 10) + ' more' : '') +
            '. Are you sure?'
        }).afterClosed().subscribe(
          result => {
            if (result) {
              items.forEach(
                item => {
                  this.printOneRoll(item);
                }
              )
              this._dialogService.openAlert({ title: 'Printed!', message: 'Labels sent to queue' });
            }
          }
        )
      }
    );
  }

  printOneRoll(piece) {
    // Fill in the gaps from the product view
    this._productService.getOneProductFromExternalName(piece.collection, piece.design, piece.color).subscribe(
      (product: Product) => {

        console.log('product by external names:', product);

        if (product != null && product.id && product.id != '0') {
          this.sendPrintJob(piece, product);
        } else {
          // Product information could not be retrieved using external names
          // Try internal names
          this._productService.getOneProductByName(piece.collection, piece.design, piece.color, false).subscribe(
            (productInt: Product) => {

              console.log('product by internal names:', productInt);

              if (productInt != null && productInt.id && productInt.id != '0') {
                this.sendPrintJob(piece, productInt);
              } else {
                // Product information could not be retrieved
                this._dialogService.openAlert({ title: 'Error', message: 'Matching product information could not be retrieved' });
              }
            });
        }
      }
    );
  }

  sendPrintJob(piece, product) {
    this._printingService.print(
      {

        company_name: piece.branch_name,
        collection: product.collection_name,
        design: product.design_name,
        part_number: piece.piece_no,
        color: product.name,
        grade_cut: piece.grade_code,
        lot_no: piece.lot_no,
        unit_type: product.unit_type,

        meters: product.unit_type === 'LENGTH' ? piece.length : 0,
        yards: product.unit_type === 'LENGTH' ? (piece.length * 1.09361).toFixed(2) : 0,
        meters_sq: product.unit_type === 'AREA' ? piece.length : 0,
        sq_feet: product.unit_type === 'AREA' ? (piece.length * 10.7639).toFixed(2) : 0,

        kilos: piece.weight,
        composition: product.composition,
        width: product.width,
        weight: product.weight_gsm

      }, this._authService.getPrinterId(), 1, 'roll').subscribe(
        response => {
          this._dialogService.openAlert({ title: 'Printed!', message: 'Label sent to queue' });
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/orion/Projects/simplicityEngine/valmust/valmustfe/src/app/agatextscreens/pda/receiving/print-labels/print-labels.component.ts